<template>
  <div :id="'grape-' + grape.id" class="grape pure-g grape-wrap" :data-doc-id="grape.docID" :data-grape-id="grape.id" :data-source-id="grape.sourceID" :data-grape-username="grape.grapeUsername" :data-type="grape.grapeType" :data-single="single" :data-pro="isPress">
    <div class="share-grape-overlay pure-u-1" v-if="shareGrapeActive">
      <div class="share-grape-inner">
        <a href="#" v-on:click.stop.prevent="grapeShareClose" class="modal-close"><i class="fal fa-times"></i></a>
        <h3>Share this grape on</h3>
        <ul class="aux-links">
          <li class="twitter"><a :href="'https://twitter.com/intent/tweet?text=Read ' + grape.grapeTitle + ' on Grapevine - ' + grapePath + grape.id" target="_blank" v-on:click="shareGrape('twitter')"><i class="fab fa-twitter"></i></a></li>
          <li class="facebook"><a :href="'https://www.facebook.com/sharer/sharer.php?u=' + grapePath + grape.id" target="_blank" v-on:click="shareGrape('facebook')"><i class="fab fa-facebook"></i></a></li>
          <li class="comment"><a :href="grapePath + grape.id" target="_blank" v-on:click.stop.prevent="shareGrape('link')"><i class="fal fa-link"></i></a></li>
        </ul>
      </div>
    </div>
    <div class="grape-edit-wrap" v-if="grapeEditActivated">
      <GrapeForm formType="edit-inline" :editGrapeID="grape.id" />
    </div>
    <div class="pure-g grape-outer-wrap">
      <div class="grape-details pure-u-1">
        <div class="username"><router-link class="button is-primary" v-on:click.stop.native="grapeUserTrigger()" v-bind:to="{ name: userLinkName, params: { username: grape.grapeUsername }}">@<span>{{grape.grapeUsername}}</span></router-link></div>
          <div class="word-count tooltip-small" title="Word count"><span>{{grapeWordCount}}</span><i class="fal fa-align-center"></i></div>
      </div>
      <div class="grape-left hidden-mobile pure-u-1-6">
        <div class="grape-left-innner">
          <div class="grape-img-wrap hidden-mobile">
            <i class="fas fa-play" v-if="grape.sourceImage && grape.sourceImage.includes('youtube')"></i>
            <img class="grape-img lazyload" v-lazy="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage && grape.sourceImage.includes('youtube')" v-on:click="loadVideoTrigger()" />
            <img class="grape-img lazyload" v-lazy="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage && isPress" />
            <router-link :to="{ name: 'book', params: { title: encodeURI(grape.grapeSource), id: grape.sourceID }}" class="book-grapes-link"><img v-bind:class="[grape.sourceDescription != '' && grape.grapeType == 'book' ? 'grape-img lazyload tooltip' : 'grape-img lazyload']" :title="grape.sourceDescription" v-lazy="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage && !grape.sourceImage.includes('youtube') && !isPress" /></router-link>
          </div>
          <router-link :to="{ name: 'publication', params: { name: encodeURI(grape.grapePublication) }}" class="grape-source" v-if="isPress">{{grape.grapePublication}}</router-link>
          <router-link :to="{ name: 'book', params: { title: encodeURI(grape.grapeSource), id: grape.sourceID }}" class="grape-source" v-if="grape.grapeType == 'book'">{{grape.grapeSource}}</router-link>
          <a class="grape-source-link" :href="grape.grapeSource" v-if="grape.grapeType == 'url'">View original source</a>
          <span class="grape-source-date" v-if="grape.sourceDate">({{grape.sourceDate}})</span>
          <a :href="grape.grapeSource" target="_blank" v-if="isPress" class="book-ref-link pure-button accent hide-when-min">Read article</a>         
          <a :href="grape.amazonURL" target="_blank" v-if="grape.amazonURL" class="book-ref-link pure-button accent hide-when-min">Buy</a>
          <a :href="'https://www.amazon.co.uk/s/ref=sr_nr_n_0?fst=as%3Aoff&rh=n%3A266239%2Ck%3A&keywords=' + grape.grapeSource + '&ie=UTF8&tag=atgrapevine-21'" target="_blank" v-if="!grape.amazonURL && !isPress" class="book-ref-link pure-button accent hide-when-min">Buy</a>
          <span class="grape-original-date hide-when-min" v-if="grape.grapeOriginalPublishYear">First printed: <span>{{grape.grapeOriginalPublishYear}}</span></span>
          <span class="grape-translation hide-when-min" v-if="grape.grapeTranslation">Translation: {{grape.grapeTranslation}}</span>
          <span class="powered-by hidden">Powered by <img src="../assets/img/2000px-Google_2015_logo.svg.png" /> Books API</span>
          <span class="grape-tags-trigger hidden"><h5 v-on:click="grapeTagsTrigger()">What is this about?</h5></span>
        </div>
      </div>
      <div class="grape-center pure-u-2-3">
        <div class="grape-img-mobile-wrap visible-mobile">
          <i class="fas fa-play" v-if="grape.sourceImage && grape.sourceImage.includes('youtube')"></i>
          <img class="grape-img lazyload" v-lazy="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage && grape.sourceImage.includes('youtube')" v-on:click="loadVideoTrigger()" />
            <img class="grape-img lazyload" v-lazy="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage && isPress" />
            <router-link :to="{ name: 'book', params: { title: encodeURI(grape.grapeSource), id: grape.sourceID }}" class="book-grapes-link"><img v-bind:class="[grape.sourceDescription != '' && grape.grapeType == 'book' ? 'grape-img lazyload tooltip' : 'grape-img lazyload']" :title="grape.sourceDescription" v-lazy="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage && !grape.sourceImage.includes('youtube') && !isPress" /></router-link>
        </div>
        <h4 class="grape-author" v-if="isPress"><router-link class="button is-primary" v-on:click.stop.native="proGrapeAuthorTrigger()" v-bind:to="{ name: 'author', params: { name: grape.sourceAuthor }}">{{grape.sourceAuthor}}</router-link></h4>   
        <h4 class="grape-author" v-if="!isPress"><router-link class="button is-primary" v-on:click.stop.native="grapeAuthorTrigger()" v-bind:to="{ name: 'author', params: { name: grape.sourceAuthor }}">{{grape.sourceAuthor}}</router-link></h4>   
        <span class="title-divide" v-if="1==2">on</span>
        <h3 class="grape-title" v-on:click="grapeTagsTrigger()">{{grape.grapeTitle}} <i class="fal fa-plus-circle grape-tags-icon-trigger"></i></h3>
        <div class="grape-center-divide"></div>           
        <div class="grape-notes hide-when-min" v-html="grape.grapeNotes"></div>
        <div class="video-wrap" v-if="grape.grapeType == 'url'"></div>
        <div class="grape-content-wrap" v-on:click="grapeContentSelectedTrigger()">
          <div class="grape-content-preview-overlay"></div>
          <div class="grape-content" v-html="grape.grapeContent"></div>
        </div>
        <div class="grape-rate hide-when-min" v-if="isLoggedIn">
          <h5>What did you think of this grape?</h5>
          <a href="#" v-on:click.stop.prevent="rateGrape('5')" data-rating="5" class="rate-grape-link">Great</a>
          <a href="#" v-on:click.stop.prevent="rateGrape('3')" data-rating="3" class="rate-grape-link">Good</a>
          <a href="#" v-on:click.stop.prevent="rateGrape('1')" data-rating="1" class="rate-grape-link">Less so</a>
        </div>
        <div class="aux-buttons hide-when-min">
          <a class="grape-aux-button add-note-button" href="#" :data-grape-id="grape.id" v-on:click.stop.prevent="grapeTagsTrigger()">Add note</a>
          <a class="grape-aux-button share-button" href="#" :data-grape-id="grape.id" v-on:click.stop.prevent="grapeShareTrigger()">Share</a>
          <a class="grape-aux-button vine-this-button context-add-to-grapevine" href="#" :data-grape-id="grape.id">Vine this</a>
          <a class="grape-aux-button flag-this-button context-flag-grape" href="#" :data-grape-id="grape.id"><i class="fal fa-bars"></i></a>
        </div>
        <!-- <div class="input-field add-note-form hide-when-min" v-if="isLoggedIn">
          <input name="add_grape_note" placeholder="Add a note" id="add_grape_note" type="text" class="validate" autocomplete="off" maxlength="50" v-model="newGrapeNote" v-on:keyup.enter="addGrapeNote">
          <div v-on:click="addGrapeNote" class="add-note-trigger"><i class="far fa-plus"></i></div>
        </div> -->
        <div class="grape-action" v-if="currentUserID == grape.grapeUserID || this.$globals.userCanEditGrapes">
          <a href="#" class="delete-grape-inline" v-on:click.stop.prevent="deleteGrape">Delete</a><span> | </span>
          <router-link class="button is-primary" v-bind:to="{ name: 'edit-grape', params: { grapeID: grape.id }}">Edit in Full</router-link><span> | </span>
          <a href="#" class="edit-grape-inline" v-on:click.stop.prevent="editGrapeInline">Quick Edit</a>
        </div>
        <input name="grape_source" placeholder="" id="grape_source" type="hidden" class="validate" autocomplete="off" v-model="grapeSource">
        <input name="source_author" placeholder="" id="source_author" type="hidden" autocomplete="off" v-model="sourceAuthor">
        <input name="source_description" placeholder="" id="source_description" type="hidden" autocomplete="off" v-model="sourceDescription">
        <input name="source_id" placeholder="" id="source_id" type="hidden" autocomplete="off" v-model="sourceID">
        <input name="source_isbn" placeholder="" id="source_isbn" type="hidden" autocomplete="off" v-model="sourceISBN">
        <input name="source_image" placeholder="" id="source_image" type="hidden" autocomplete="off" v-model="sourceImage">
        <input name="source_date" placeholder="" id="source_date" type="hidden" autocomplete="off" v-model="sourceDate">
      </div>
      <div class="grape-right pure-u-1-6">
        <div class="grape-right-inner">
          <a class="grape-aux-button share-button" href="#" :data-grape-id="grape.id" v-on:click.stop.prevent="grapeShareTrigger()">Share</a>
          <a class="grape-aux-button vine-this-button context-add-to-grapevine" href="#" :data-grape-id="grape.id">Vine this</a>

          <div class="add-confirmation">
            <a href="#" class="add-to-grapevine hidden" data-key=""></a>
            <div class="add-trigger" v-bind:class="{ drawn: isVined }"></div>
            <svg version="1.1" id="tick" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 37 37" style="enable-background:new 0 0 37 37;" xml:space="preserve">
            <path class="circ path" style="fill:none;stroke:#1d8019;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" d="
              M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z"
              />
            <polyline class="tick path" style="fill:none;stroke:#1d8019;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" points="
              11.6,20 15.9,24.2 26.4,13.8 "/>
            </svg>
            <span>VINED</span>
            <ul class="grapes-grapevines">
            </ul>
<!-- 
            <div class="flag-wrap hide-when-min" v-if="!isPress">
              <a class="context-flag-grape" href="#" :data-grape-id="grape.id">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" enable-background="new 0 0 60 60" xml:space="preserve"><path fill="#36a731" d="M44.381,15.051L17.189,0.2c-0.507-0.277-1.123-0.266-1.62,0.029c-0.498,0.295-0.803,0.831-0.803,1.409V28.26  c-0.001,0.024-0.001,0.049,0,0.073v30.028c0,0.905,0.733,1.639,1.638,1.639c0.905,0,1.639-0.733,1.639-1.639V29.37l26.206-11.379  c0.573-0.249,0.956-0.804,0.983-1.429C45.261,15.938,44.931,15.351,44.381,15.051z M18.043,25.798V4.4l21.826,11.92L18.043,25.798z"></path></svg>
                Flag
              </a>
            </div> -->
          </div>

          <div class="grape-notes-count" v-if="grapeNotesCount > 0" v-on:click="grapeTagsTrigger()">
            <span>{{grapeNotesCount}}</span> Notes
          </div>

          <div class="login-to-rate-button-wrap" v-if="!isLoggedIn">
            <button class="pure-button" v-on:click="goToAccountPage">Log in to rate a grape.</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* global $, jQuery, LazyLoad, algoliasearch, mixpanel */
  import GrapeForm from './GrapeForm.vue'
  import db from './firebaseInit'
  import firebase from 'firebase'
  import Router from '../router'
  import Request from 'superagent'
  const crypto = require('crypto');
  import 'vuejs-noty/dist/vuejs-noty.css'

  export default {
    name: 'Grape',
    data () {
      return {
        currentUserID: null,
        currentPage: null,
        isLoggedIn: false,
        grapeEditActivated: false,
        grape: this.grapeInstance,
        grapeType: 'book',
        grapeSource: null,
        sourceID: null,
        sourceISBN: null,
        sourceDescription: null,
        sourceImage: null,
        sourceAuthor: null,
        sourceDate: null,
        grapeWordCount: 0,
        grapeIsSelected: false,
        isVined: false,
        isRated: false,
        ratingDocID: false,
        inGrapevines: [],
        grapeNotesCount: 0,
        newGrapeNote: null,
        grapesDatabase: this.$globals.grapesDatabase,
        grapevinesDatabase: this.$globals.grapevinesDatabase,
        grapeRatingsDatabase: this.$globals.grapeRatingsDatabase,
        isPress: this.$globals.isPress,
        grapePath: this.$globals.grapePath,
        userLinkName: 'user',
        shareGrapeActive: false
      }
    },
    props: {
      grapeInstance: {
        type: Object,
        required: true,
        mustProcess: false
      },
      single: false
    },
    created () {
      var vm = this
      if (this.isPress) {
        // this.grapePath = '/#/print/view-grape/'
        // this.userLinkName = 'print-user'
      }
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.currentUserID = user.uid
          vm.isLoggedIn = true
          vm.checkGrapeIsRated()
        }
      })
      this.currentPage = window.location.pathname
      this.getGrapeWordCount()

      // Adjustments
      this.grapeAdjustments()

      // get notes
      this.getNotes()

      // Check grapevines
      setTimeout(function () {
        vm.checkGrapevines()
      }, 2000)
    },
    methods: {
      getNotes: function () {
        let vm = this
        var notesRef = db.collection('grapeNotes').where('grapeID', '==', this.grape.id)
        notesRef.get().then((querySnapshot) => {
          vm.grapeNotesCount = querySnapshot.docs.length
        })
      },
      addGrapeNote: function () {
        $('#add_grape_note').prop('disabled', true)
        let vm = this
        let userID = vm.currentUserID
        let noteData = {
          'grapeID': this.grape.id,
          'userID': userID,
          'username': vm.$globals.userUsername,
          'text': vm.newGrapeNote,
          'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
        }
        mixpanel.track(
          'Create grape note',
          {
            'grapeID': vm.selectedGrapeID
          }
        )
        db.collection('grapeNotes').add(noteData).then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          vm.$noty.success('Note added to Grape')
          vm.newGrapeNote = ''
          $('#add_grape_note').prop('disabled', false)
          vm.grapeNotesCount++
          noteData.id = docRef.id
          vm.$eventHub.$emit('grape-tags-trigger', vm.grape.id, vm.grape.grapeTitle)
        }).catch(function (error) {
          console.error('Error adding document: ', error)
          $('#add_grape_note').prop('disabled', false)
        })
      },
      grapeAdjustments () {
        this.grape.grapeContent = this.grape.grapeContent.charAt(0).toUpperCase() + this.grape.grapeContent.slice(1)
        if (this.grape.grapeNotes) {
          this.grape.grapeNotes = this.grape.grapeNotes.charAt(0).toUpperCase() + this.grape.grapeNotes.slice(1)
        }
        if (this.grape.grapeTranslation) {
          this.grape.grapeTranslation = this.grape.grapeTranslation.charAt(0).toUpperCase() + this.grape.grapeTranslation.slice(1)
          this.grape.grapeTranslation = this.grape.grapeTranslation.split('.').join('')
        }
        if (this.grape.grapeOriginalPublishYear) {
          this.grape.grapeOriginalPublishYear = this.grape.grapeOriginalPublishYear + ''
          this.grape.grapeOriginalPublishYear = this.grape.grapeOriginalPublishYear.split('.').join('')
        }
        this.grape.grapeTitle = this.grape.grapeTitle.split('.').join('')
        if (this.grape.grapeType === 'book') {
          this.grape.grapeSource = this.grape.grapeSource.split('.').join('')
        }
        if (this.grape.sourceAuthor) {
          this.grape.sourceAuthor = this.grape.sourceAuthor.split('.').join('')        
        }

        // Other adjustments
        if (this.grape.grapeType === 'book' && this.grape.grapeSource && this.grape.grapeSource.length >= 40) {
          this.grape.grapeSource = this.grape.grapeSource.substring(0, 40) + '...'
        }

        if (this.grape.sourceDescription && this.grape.grapeType !== 'book') {
          this.grape.sourceDescription = ''
        }

        if (this.grape.sourceDate && this.grape.sourceDate.length > 4) {
          this.grape.sourceDate = this.grape.sourceDate.substring(0, 4)
        }

        if (this.grape.sourceDescription) {
          this.grape.sourceDescription = this.grape.sourceDescription.length > 280 ? this.grape.sourceDescription.substring(0, 280) + '...' : this.grape.sourceDescription
        }

        if (!this.grape.sourceImage && this.isPress) {
          this.grape.sourceImage = 'https://press.atgrapevine.com/static/img/' + this.grape.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
        }
      },
      getGrapeWordCount () {
        var regex = /\s+/gi
        this.grapeWordCount = this.grape.grapeContent.trim().replace(regex, ' ').split(' ').length
      },
      editGrapeInline () {
        this.grapeEditActivated = true
        var element = document.getElementById('grape-' + this.grape.id)
        element.classList.add('is-editing')
        $('body').addClass('is-editing-inline')
      },
      inlineEditCancelled () {
        this.grapeEditActivated = false
        var element = document.getElementById('grape-' + this.grape.id)
        element.classList.remove('is-editing')
        $('body').removeClass('is-editing-inline')
      },
      inlineEditSaved () {
        let vm = this
        console.log('inlineEditSaved')
        mixpanel.track(
          'Inline edit saved',
          {
            'grapeID': vm.grapeInstance.id
          }
        )
        var grapeRef = db.collection(vm.grapesDatabase).where('id', '==', vm.grapeInstance.id).limit(1)
        grapeRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            vm.grape = doc.data()
            vm.grapeAdjustments()
            vm.replaceGrapeTextSymbols()
            vm.grapeEditActivated = false
            var element = document.getElementById('grape-' + vm.grape.id)
            element.classList.remove('is-editing')
            $('body').removeClass('is-editing-inline')
          })
        })
      },
      deleteGrape () {
        let vm = this
        var retVal = confirm('Are you sure you want to delete this grape?')
        if (retVal === true) {
          mixpanel.track(
            'Grape deleted',
            {
              'grapeID': vm.grape.id
            }
          )
          var grapeRef = db.collection(vm.grapesDatabase).doc(vm.grape.docID)
          grapeRef.delete().then(function () {
            console.log('Document successfully deleted!')
            $('#grape-' + vm.grape.id).slideUp(400)
          }).catch(function (error) {
            console.error('Error removing document: ', error)
          })
          return true
        } else {
          return false
        }
      },
      checkGrapevines () {
        let vm = this
        vm.inGrapevines = []
        if (vm.$globals.userGrapevines) {
          for (var i = 0; i < vm.$globals.userGrapevines.length; i++) {
            var thisGrapevine = vm.$globals.userGrapevines[i]
            var grapes = thisGrapevine.grapes
            if ($.inArray(vm.grape.id, grapes) > -1) {
              vm.isVined = true
              $('#grape-' + vm.grape.id).find('.add-confirmation').addClass('added')
              $('#grape-' + vm.grape.id).find('.grapes-grapevines').append('<li><a href="/grapevine/' + thisGrapevine.id + '/' + thisGrapevine.name + '" class="list-link">' + thisGrapevine.name + '</a></li>')
              var grapevineData = {
                name: thisGrapevine.name,
                id: thisGrapevine.id
              }
              vm.inGrapevines.push(grapevineData)
            }
          }
        }
      },
      lookupUsername (grape) {
        firebase.database().ref('users/' + grape.grapeUserID).once('value', function (snapshot) {
          var username = (snapshot.val() && snapshot.val().username) || 'grapevine'
          if (username !== '') {
            grape.username = username
            var grapeRef = db.collection(vm.grapesDatabase).doc(grape.docID)
            var grapeID = grape.docID
            grapeRef.update({
              grapeUsername: username
            })
            .then(function () {
              console.log('Document ' + grapeID + ' successfully updated username to ' + username + ' (id: ' + grape.grapeUserID + ')!')
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error('Error updating document: ', error)
            })
          }
        })
      },
      addTimestamp (grape) {
        var grapeRef = db.collection(vm.grapesDatabase).doc(grape.docID)
        var grapeID = grape.docID
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        grapeRef.update({
          updatedTimestamp: timestamp
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated timestamp!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      adjustGrapeContent ($text) {
        this.grape.grapeContent = $text
      },
      replaceGrapeTextSymbols () {
        var text = this.grape.grapeContent
        //text = text.replace(/-\s/g, '')
        //text = text.replace(/—/g, '&#8211;')
        text = text.replace(/--/g, '–')
        text = text.replace(/ - /g, '&#8211;')
        text = text.replace(/ -&nbsp;/g, '&#8211;')
        text = text.replace(/ {2}- {2}/g, ' – ')
        text = text.replace(/ {2}– /g, ' – ')
        text = text.replace(/ – {2}/g, ' – ')
        //text = text.replace(/([a-zA-Z0-9"'])\-([a-zA-Z0-9"'])/g, '$1 &#8211; $2') /* Ensure spaces between in-word hyphen */
        text = text.replace(/([a-zA-Z0-9"'])—([a-zA-Z0-9"'])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9"'])\—([a-zA-Z0-9"'])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9"'])—([a-zA-Z0-9"'])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9"'])–([a-zA-Z0-9"'])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9"'])&#8211;([a-zA-Z0-9"'])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9"'])&#8212;([a-zA-Z0-9"'])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/\.([a-zA-Z0-9"'])/g, '. $1') /* Ensure space after full stop */
        text = text.replace(/\!([a-zA-Z0-9"'])/g, '! $1') /* Ensure space after exclamation mark */
        text = text.replace(/\?([a-zA-Z0-9"'])/g, '? $1') /* Ensure space after question mark */
        text = text.replace(/ &#8211;([a-zA-Z0-9"'])/g, ' &#8211; $1') /* Ensure space after — */
        text = text.replace(/&#8211; ([a-zA-Z0-9"'])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/— ([a-zA-Z0-9"'])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/ —([a-zA-Z0-9"'])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/– ([a-zA-Z0-9"'])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/ –([a-zA-Z0-9"'])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/\. \" /g, '.\" ') /* Remove space between full stop and quotemark */
        text = text.replace(/\? \" /g, '?\" ') /* Remove space between question mark and quotemark */
        text = text.replace(/\! \" /g, '!\" ') /* Remove space between exclamation mark and quotemark */
        text = text.replace(/\. \' /g, '.\' ') /* Remove space between full stop and quotemark */
        text = text.replace(/\? \' /g, '?\' ') /* Remove space between question mark and quotemark */
        text = text.replace(/\! \' /g, '!\' ') /* Remove space between exclamation mark and quotemark */
        // text = text.replace(/.\s*([a-z])/g, function(d,e) { return '. ' + e.toUpperCase() }) /* Ensure capital letter after full stop */
        text = text.replace(/ ofa /g, ' of a ') /* Change 'ofa' to 'of a' */
        text = text.replace(/ ofthe /g, ' of the ') /* Change 'ofa' to 'of a' */
        text = text.replace(/”/g, '\'') /* Change ” to ' */
        text = text.replace(/ {2}/g, ' ') /* Change double spacing to single */
        text = text.replace(/\+>/g, '+ >')
        text = text.replace(/\.{\+}/g, '. <i class="fal fa-genderless"></i>')
        text = text.replace(/\(\+\)/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\{\+}/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\.\+/g, '. <i class="fal fa-genderless"></i>')
        text = text.replace(/\+/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\.{>}/g, '. <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{>}/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{&gt;}/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{<}/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/\{&lt;}/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/ >/g, ' <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\. >/g, '. <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/&gt;/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/ &gt;/g, ' <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/&lt;/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/><\/i><i/g, '></i> <i')
        this.grape.grapeContent = text
      },
      saveNewGrapeContent ($text) {
        this.grapeContent = $text
        var grapeRef = db.collection(vm.grapesDatabase).doc(this.grape.docID)
        var grapeID = this.grape.docID
        grapeRef.update({
          grapeContent: this.grapeContent
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated with book info!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      saveData (grape) {
        console.log('saving data: ' + grape.id)
        var grapeRef = db.collection(vm.grapesDatabase).doc(grape.docID)
        var grapeID = grape.docID
        grapeRef.update({
          sourceISBN: this.sourceISBN
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated with book info!')
          const timestamp = firebase.firestore.FieldValue.serverTimestamp()
          grapeRef.update({ updatedTimestamp: timestamp })
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      generateUUID () {
        let d = new Date().getTime()
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return uuid
      },
      createGrapevineWithGrape (grapevineName, grapeID) {
        let vm = this
        let userID = vm.currentUserID
        var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
        let grapevineData = {
          'name': grapevineName,
          'privacy': 'public',
          'userID': userID,
          'grapes': [],
          'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp(),
          'random': random
        }
        mixpanel.track(
          'Create grapevine',
          {
            'grapevineName': grapevineName
          }
        )
        db.collection(vm.grapevinesDatabase).add(grapevineData).then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          vm.$eventHub.$emit('new-grapevine-created', docRef.id)
          vm.$noty.success('Grapevine created')
          vm.addGrapeToGrapevine(docRef.id, grapeID)
        })
      },
      flagGrape (content, key, grapeID) {
        let vm = this
        let userID = vm.currentUserID
        let flagData = {
          'grapeID': grapeID,
          'grapeAuthor': vm.grape.sourceAuthor,
          'grapeTitle': vm.grape.grapeTitle,
          'grapeContent': vm.grape.grapeContent,
          'userID': userID,
          'flag-type': key,
          'text': content,
          'reviewed': false,
          'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
        }
        mixpanel.track(
          'Create grape flag',
          {
            'flagType': key,
            'grapeID': grapeID
          }
        )
        db.collection('grapeFlags').add(flagData).then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          vm.$noty.success('Flag sent to Grapevine')
        })
      },
      addGrapeToGrapevine (grapevineID, grapeID) {
        let vm = this
        let grapevineRef = db.collection(vm.grapevinesDatabase).doc(grapevineID)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            var name = doc.data().name
            var id = doc.id
            var grapes = doc.data().grapes

            // if (doc.data().groupvine) {
            //   if (vm.currentUserID in doc.data().participantIDs) {
            //     var userGrapesRef = db.collection('grapevines').doc(grapevineID).collection('participants').doc(vm.currentUserID);
            //     userGrapesRef.get().then(function (doc) {
            //       if (doc.exists) {
            //         console.log('1')
            //         var grapes = doc.data().grapes
            //         if ($.isArray(grapes)) {
            //           if ($.inArray(grapeID, grapes) === -1) {
            //             grapes.push(grapeID)
            //             userGrapesRef.update({
            //               grapes: grapes,
            //               modifiedGrapeID: grapeID,
            //               modifiedGrapeAction: 'added'
            //             })
            //           }
            //         } else {
            //           console.log('2')
            //           userGrapesRef.update({
            //             grapes: [grapeID],
            //             modifiedGrapeID: grapeID,
            //             modifiedGrapeAction: 'added'
            //           })
            //         }
            //       } else {
            //         console.log('3')
            //         db.collection('grapevines').doc(grapevineID).collection('participants').doc(vm.currentUserID).set({
            //           grapes: [grapeID]
            //         })
            //       }
            //     })
            //   }
            // } else {
              if ($.isArray(grapes)) {
                if ($.inArray(grapeID, grapes) === -1) {
                  grapes.push(grapeID)
                  grapevineRef.update({
                    grapes: grapes,
                    modifiedGrapeID: grapeID,
                    modifiedGrapeAction: 'added'
                  })
                }
              } else {
                grapevineRef.update({
                  grapes: [grapeID],
                  modifiedGrapeID: grapeID,
                  modifiedGrapeAction: 'added'
                })
              }
            // }

            // grape added cloud function
            const req = Request
            .post('https://us-central1-grapevine-dc853.cloudfunctions.net/grapeAddedToGrapevine')
            .query({
              grapevineID: grapevineID,
              userID: vm.currentUserID,
              username: vm.$globals.userUsername,
              grapeData: vm.grape,
              grapeID: grapeID
            })
            .then(function() {
              console.log('grape added to grapevine cloud function')
            })  

            // push to ingrapevines
            var grapevineData = {
              name: name,
              id: grapevineID
            }
            vm.inGrapevines.push(grapevineData)

            // update vined
            $('#grape-' + grapeID).find('.add-trigger').addClass('drawn')
            $('#grape-' + grapeID).find('.add-confirmation').addClass('added')
            $('#grape-' + grapeID).find('.grapes-grapevines').append('<li><a href="#/grapevine/' + grapevineID + '/' + name + '" class="list-link">' + name + '</a></li>')
            setTimeout(function () {
              vm.isVined = true
            }, 1000)
            vm.$noty.success('Grape added to grapevine')
            vm.$eventHub.$emit('grape-add-to-grapevine', grapevineID)
            mixpanel.track(
              'Added grape to grapevine',
              {
                'grapevineID': grapevineID,
                'grapeID': grapeID
              }
            )
          }
        })
      },
      grapeTagsTrigger () {
        this.$eventHub.$emit('grape-tags-trigger', this.grape.id, this.grape.grapeTitle)
      },
      grapeUserTrigger () {
        console.log('grapeUserTrigger')
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        this.$eventHub.$emit('grape-user-trigger', this.grape.grapeUserID, this.grape.grapeUsername)
      },
      grapeAuthorTrigger () {
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        this.$eventHub.$emit('grape-author-trigger')
      },
      grapeShareTrigger () {
        this.shareGrapeActive = true
      },
      grapeShareClose () {
        this.shareGrapeActive = false
      },
      grapeContentSelectedTrigger () {
        var $highlightedText = ''
        if (window.getSelection) {
          $highlightedText = window.getSelection().toString()
        }
        let vm = this
        let grapeID = vm.grape.id
        let grapeTitle = vm.grape.grapeTitle
        if ($highlightedText === '') {
          if (this.grapeIsSelected) {
            console.log('goback')
            history.pushState({}, null, vm.currentPage)
            $('body').removeClass('grape-is-selected')
            this.grapeIsSelected = false
          } else {
            console.log('push url, with grape id: ' + grapeID)
            mixpanel.track(
              'Grape viewed',
              {
                'grapeID': grapeID,
                'grapeTitle': grapeTitle
              }
            )
            if (window.location.href.indexOf('view-grape') > -1) {
              history.pushState({}, null, vm.currentPage)
              setTimeout(function () {
                history.pushState({}, null, vm.grapePath + grapeID)
                let grapeTop = $('#grape-' + grapeID).offset().top - 80
                $('html, body').animate({ scrollTop: grapeTop }, 'slow')
                this.grapeIsSelected = true
                $('.body').addClass('grape-is-selected')
              }, 300)
            } else {
              history.pushState({}, null, vm.grapePath + grapeID)
              let grapeTop = $('#grape-' + grapeID).offset().top - 80
              $('html, body').animate({ scrollTop: grapeTop }, 'slow')
              this.grapeIsSelected = true
              $('body').addClass('grape-is-selected')
            }
          }
        }
      },
      shareGrape (network) {
        let vm = this
        mixpanel.track(
          'Grape Shared',
          {
            'network': network,
            'grapeID': vm.grape.id
          }
        )
        if (network === 'link') {
          var dummy = document.createElement('input'),
              text = vm.grapePath + vm.grape.id;

          document.body.appendChild(dummy);
          dummy.value = text;
          dummy.select();
          document.execCommand('copy');
          document.body.removeChild(dummy);
          vm.$noty.success('Link copied')
        }
      },
      rateGrape (rating) {
        let vm = this
        $('#grape-' + vm.grape.id).find('.rate-grape-link').removeClass('current-rating')
        $('#grape-' + vm.grape.id).find('.rate-grape-link[data-rating="' + rating + '"]').addClass('current-rating')
        if (vm.isRated) {
          var ratingRef = db.collection(vm.grapeRatingsDatabase).doc(vm.ratingDocID)
          const timestamp = firebase.firestore.FieldValue.serverTimestamp()
          var updateRatingData = {
            rating: rating,
            updatedTimestamp: timestamp,
            username: vm.$globals.userUsername,
          }
          ratingRef.update(updateRatingData)
          .then(function () {
            console.log('Document rating updated')
            vm.$eventHub.$emit('grape-rated-trigger')
          })
          .catch(function (error) {
            console.error('Error updating document: ', error)
          })
        } else {
          const timestamp = firebase.firestore.FieldValue.serverTimestamp()
          var ratingData = {
            rating: rating,
            grapeID: vm.grape.id,
            userID: vm.currentUserID,
            username: vm.$globals.userUsername,
            createdTimestamp: timestamp
          }
          db.collection(vm.grapeRatingsDatabase).add(ratingData)
          .then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.isRated = true
            vm.$eventHub.$emit('grape-rated-trigger')

          })
          .catch(function (error) {
            console.error('Error adding document: ', error)
          })
        }
        mixpanel.track(
          'Grape Rated',
          {
            'rating': rating,
            'grapeID': vm.grape.id
          }
        )
      },
      checkGrapeIsRated () {
        let vm = this
        // console.log('checkGrapeIsRated grape: ' + vm.grape.id + ', userID: ' + vm.currentUserID)
        if (vm.grape.id && vm.currentUserID) {
          var ratingRef = db.collection(vm.grapeRatingsDatabase).where('grapeID', '==', vm.grape.id).where('userID', '==', vm.currentUserID).limit(1)
          ratingRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.exists) {
                vm.isRated = true
                vm.ratingDocID = doc.id
                var ratingData = doc.data()
                let rating = ratingData.rating
                $('#grape-' + vm.grape.id).find('.rate-grape-link[data-rating="' + rating + '"]').addClass('current-rating')
              }
            })
          })
        }
      },
      loadVideoTrigger () {
        console.log('loadVideoTrigger')
        let vm = this
        let thisGrape = $('#grape-' + vm.grape.id)

        if (thisGrape.find('.video-wrap').hasClass('video-open')) {
          thisGrape.find('.video-wrap').removeClass('video-open')
          thisGrape.find('.video-wrap').empty()
        } else {
          if (this.grape.bookType !== 'url') {
            var videoURL = vm.grape.grapeSource
            var urlCheck = parseVideo(videoURL)
            console.log(videoURL + ' ' + urlCheck)
            if (urlCheck.type === 'youtube' || urlCheck.type === 'vimeo') {
              var video = createVideo(videoURL, 500, 300)
              thisGrape.find('.video-wrap').append(video)
              thisGrape.find('.video-wrap').addClass('video-open')
            }
          }
        }

        function parseVideo (url) {
          // - Supported YouTube URL formats:
          //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
          //   - http://youtu.be/My2FRPA3Gf8
          //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
          // - Supported Vimeo URL formats:
          //   - http://vimeo.com/25451551
          //   - http://player.vimeo.com/video/25451551
          // - Also supports relative URLs:
          //   - //player.vimeo.com/video/25451551

          var originalURL = url
          var ID = ''
          if (url.includes('&t=')) {
            url = url.substr(0, url.indexOf('&t='))
          } else if (url.includes('?t=')) {
            url = url.substr(0, url.indexOf('?t='))
          }
          url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/)

          var type = ''
          if (RegExp.$3.indexOf('youtu') > -1) {
            type = 'youtube'
            var getID = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
            ID = (getID[2] !== undefined) ? getID[2].split(/[^0-9a-z_-]/i)[0] : getID[0]
          } else if (RegExp.$3.indexOf('vimeo') > -1) {
            type = 'vimeo'
            ID = RegExp.$10
          }

          var $timeStamp = originalURL.match('t=(.)*?[&|(s)]')
          if ($timeStamp && $timeStamp !== '') {
            var hours = $timeStamp[0].match(/(\d+)h/)
            var minutes = $timeStamp[0].match(/(\d+)m/)
            var seconds = $timeStamp[0].match(/(\d+)s/)
            var totalTimeInSeconds = 0
            if (hours) {
              totalTimeInSeconds += parseInt(hours[1], 10) * 60 * 60
            }
            if (minutes) {
              totalTimeInSeconds += parseInt(minutes[1], 10) * 60
            }
            if (seconds) {
              totalTimeInSeconds += parseInt(seconds[1], 10)
            }
            $timeStamp = totalTimeInSeconds
          }

          return {
            type: type,
            id: ID,
            timestamp: $timeStamp !== '' ? $timeStamp : false
          }
        }

        function createVideo (url, width, height) {
          // Returns an iframe of the video with the specified URL.
          var videoObj = parseVideo(url)
          var $iframe = $('<iframe>', { width: width, height: height })
          $iframe.attr('frameborder', 0)
          var $src = ''
          if (videoObj.type === 'youtube') {
            $src = '//www.youtube.com/embed/' + videoObj.id
            $src += '?start=' + videoObj.timestamp
            $iframe.attr('src', $src)
          } else if (videoObj.type === 'vimeo') {
            $iframe.attr('src', '//player.vimeo.com/video/' + videoObj.id)
          }
          return $iframe
        }
      },
      goToAccountPage: function () {
        console.log('goToAccountPage')
        Router.push({name: 'account'})
      }
    },
    mounted () {
      /**********************************************
      ***
      *** Trigger2 function
      ***
      **********************************************/
      // trigger2 function
      (function ($) {
        $.fn.trigger2 = function (eventName) {
          return this.each(function () {
            var el = $(this).get(0)
            triggerNativeEvent(el, eventName)
          })
        }

        function triggerNativeEvent (el, eventName) {
          if (el.fireEvent) { // < IE9
            (el.fireEvent('on' + eventName))
          } else {
            var evt = document.createEvent('Events')
            evt.initEvent(eventName, true, false)
            el.dispatchEvent(evt)
          }
        }

        $('.tooltip').tooltip({
          items: '[title]',
          classes: {
            'ui-tooltip': 'ui-grape-img-tooltip'
          },
          position: { my: 'left top', at: 'center', collision: 'none' },
          content: function () {
            var element = $(this)
            if (element.is('[title]') & element.hasClass('grape-img')) {
              return element.attr('title') + '<span>per Google Books</span>'
            } else {
              return element.attr('title')
            }
          },
          delay: 2000,
          open: function (event, ui) {
            if (typeof (event.originalEvent) === 'undefined') {
              return false
            }
            var $id = $(ui.tooltip).attr('id')
            // close any lingering tooltips
            $('div.ui-tooltip').not('#' + $id).remove()
          },
          close: function (event, ui) {
            ui.tooltip.hover(function () {
              $(this).stop(true).fadeTo(400, 1)
            },
            function () {
              $(this).fadeOut('400', function () {
                $(this).remove()
              })
            })
          }
        })

        $('.tooltip-small').tooltip({
          items: '[title]',
          classes: {
            'ui-tooltip': 'ui-grape-small-tooltip'
          },
          position: { my: 'left top', at: 'left bottom', collision: 'none' },
          content: function () {
            var element = $(this)
            return element.attr('title')
          },
          delay: 2000,
          open: function (event, ui) {
            if (typeof (event.originalEvent) === 'undefined') {
              return false
            }
            var $id = $(ui.tooltip).attr('id')
            // close any lingering tooltips
            $('div.ui-tooltip').not('#' + $id).remove()
          },
          close: function (event, ui) {
            ui.tooltip.hover(function () {
              $(this).stop(true).fadeTo(400, 1)
            },
            function () {
              $(this).fadeOut('400', function () {
                $(this).remove()
              })
            })
          }
        })

      }(jQuery))

      /**********************************************
      ***
      *** Context Menu function
      ***
      **********************************************/
      let $vue = this
      $.contextMenu({
        selector: '.context-add-to-grapevine',
        trigger: 'left',
        // className: 'limit-context-size',
        build: function ($trigger, e) {
          // this callback is executed every time the menu is to be shown
          // its results are destroyed every time the menu is hidden
          // e is the original contextmenu event, containing e.pageX and e.pageY (amongst other data)           
          if ($vue.currentUserID) {
            var $grapeID = e.target.dataset.grapeId
            var $grapevineItems = {}
            $grapevineItems['create-new-grapevine'] = {
              'name': 'New Grapevine',
              'icon': '',
              'className': 'new-grapevine-trigger'
            }
            $grapevineItems['seperator'] = {
              'type': 'cm_separator'
            }
            $('#my-grapevines-list').find('li').each(function () {
              var $thisGrapevine = $(this)
              if (!$thisGrapevine.data('read-only')) {
                var $grapevineObject = {}
                $grapevineObject['name'] = $thisGrapevine.data('name')
                $grapevineObject['icon'] = ''
                $grapevineItems[$thisGrapevine.data('id')] = $grapevineObject
              }
            })
          } else {
            var $grapevineItems = {}
            $grapevineItems['login-signup-trigger'] = {
              'name': 'Please login to vine',
              'icon': '',
              'className': 'login-signup-trigger'
            }
          }
          return {
            callback: function (key, options) {
              // var m = 'clicked: ' + key
              // window.console && console.log(m) || alert(m)
              if (key === 'create-new-grapevine') {
                $('body').append('<div id="dialog-new-grapevine"><input id="context_new_grapevine_name" name="context_new_grapevine_name" type="text" placeholder="Grapevine name" /></div>')
                $('#dialog-new-grapevine').dialog({
                  title: 'Create new grapevine',
                  buttons: {
                    'Create grapevine': function () {
                      $(this).dialog('close')
                      var $newGrapevineName = $(document).find('#context_new_grapevine_name').val()
                      $vue.createGrapevineWithGrape($newGrapevineName, $grapeID)
                      $('#dialog-new-grapevine').remove()
                    },
                    Cancel: function () {
                      $(this).dialog('close')
                      $('#dialog-new-grapevine').remove()
                    }
                  }
                })
                $('#dialog-new-grapevine').dialog('open')
              } else if (key === 'login-signup-trigger') {
                $vue.goToAccountPage()
              } else {
                $vue.addGrapeToGrapevine(key, $grapeID)
              }
            },
            items: $grapevineItems
          }
        }
      })
      $.contextMenu({
        selector: '.context-flag-grape',
        trigger: 'left',
        // className: 'limit-context-size',
        build: function ($trigger, e) {
          // this callback is executed every time the menu is to be shown
          // its results are destroyed every time the menu is hidden
          // e is the original contextmenu event, containing e.pageX and e.pageY (amongst other data)
          if ($vue.currentUserID) {
            var $grapeID = e.target.dataset.grapeId
            var $flagItems = {}
            $flagItems['heading'] = {
              'name': 'Flag this grape',
              'disabled': true,
              'type': 'html',
              'html': '<h4>Flag this grape</h4>'
            }
            $flagItems['spelling-punctuation'] = {
              'name': 'Spelling/Punctuation'
            }
            $flagItems['incorrect'] = {
              'name': 'Incorrect'
            }
            $flagItems['unfair-omissions'] = {
              'name': 'Unfair omissions'
            }
            $flagItems['abusive'] = {
              'name': 'Abusive'
            }
          } else {
            var $flagItems = {}
            $flagItems['login-signup-trigger'] = {
              'name': 'Please login to flag',
              'icon': '',
              'className': 'login-signup-trigger'
            }
          }
          return {
            callback: function (key, options) {
              // var m = 'clicked: ' + key
              // window.console && console.log(m) || alert(m)
              if (key === 'login-signup-trigger') {
                $vue.goToAccountPage()
              } else {
                $('body').append('<div id="dialog-new-flag"><textarea id="context_flag_content" name="context_flag_content" type="text" placeholder="Please provide details for the issue" /></textarea>')
                $('#dialog-new-flag').dialog({
                  title: 'Flag grape',
                  buttons: {
                    'Submit': function () {
                      $(this).dialog('close')
                      var $flagContent = $(document).find('#context_flag_content').val()
                      $vue.flagGrape($flagContent, key, $grapeID)
                      $('#dialog-new-flag').remove()
                    },
                    Cancel: function () {
                      $(this).dialog('close')
                      $('#dialog-new-flag').remove()
                    }
                  }
                })
                $('#dialog-new-flag').dialog('open')
              }
            },
            items: $flagItems
          }
        }
      })

      /**********************************************
      ***
      *** Get book data if needed
      ***
      **********************************************/
      var $getNewData = false
      var $getNewData2 = false
      var $getNewData3 = false
      var $grapeSourceID = $vue.grape.sourceID
      var booksUrl = ''

      if ($getNewData && $vue.grape.grapeType === 'book' && !$vue.grape.sourceISBN) {
        // Query book
        booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=id:"' + $grapeSourceID + '"&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'
        $.ajax({
          url: booksUrl,
          dataType: 'jsonp',
          success: function (data) {
            if (data.items) {
              for (var i = 0; i < data.items.length; i++) {
                var item = data.items[i]
                if (item.id !== $grapeSourceID) {
                  console.log('ID does not match case sensitivity, sourceID: ' + $grapeSourceID + ', item.id: ' + item.id)
                  continue
                } else {
                  console.log(item)
                  if (item.volumeInfo.industryIdentifiers) {
                    var ISBNs = item.volumeInfo.industryIdentifiers
                    var ISBNFinal = ''
                    var ISBN13 = ''
                    var ISBN10 = ''
                    var ISBNOther = ''
                    for (var j = 0; j < ISBNs.length; j++) {
                      var thisISBN = ISBNs[j]
                      if (thisISBN.type === 'ISBN_13') {
                        ISBN13 = thisISBN.identifier
                      } else if (thisISBN.type === 'ISBN_10') {
                        ISBN10 = thisISBN.identifier
                      } else {
                        // ISBNOther = thisISBN.identifier
                        ISBNOther = ''
                      }
                    }
                    if (ISBN13 !== '') {
                      ISBNFinal = ISBN13
                    } else if (ISBN10 !== '') {
                      ISBNFinal = ISBN10
                    } else {
                      ISBNFinal = ISBNOther
                    }
                    $('#grape-' + $vue.grape.id + ' #source_isbn').val(ISBNFinal).trigger2('input')
                    // $vue.saveData($vue.grape)
                  }
                  break
                }
              }
            }
          }
        })
      }

      if ($getNewData2 && $vue.grape.sourceID && $vue.grape.grapeType === 'book') {
        // Query book
        booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=id:"' + $vue.grape.sourceID + '"&maxResults=1&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'
        $.ajax({
          url: booksUrl,
          dataType: 'jsonp',
          success: function (data) {
            for (var i = 0; i < 1; i++) {
              if (data.items && data.items.length > 0) {
                var item = data.items[i]
                if (item.volumeInfo.description) {
                  // $('#grape-' + $vue.grape.id + ' #grape_source').val(item.volumeInfo.title).trigger2('input')
                  // var image = (item.volumeInfo.imageLinks == null ? '' : item.volumeInfo.imageLinks.thumbnail)
                  // if (image !== '') {
                  //   $('#grape-' + $vue.grape.id + ' #source_image').val(image).trigger2('input')
                  // }
                  // if (item.volumeInfo.industryIdentifiers && item.volumeInfo.industryIdentifiers[0].identifier) {
                  // $('#grape-' + $vue.grape.id + ' #source_isbn').val(item.volumeInfo.industryIdentifiers[0].identifier).trigger2('input')
                  // }
                  // $('#grape-' + $vue.grape.id + ' #source_author').val(item.volumeInfo.authors).trigger2('input')
                  // $('#grape-' + $vue.grape.id + ' #source_date').val(item.volumeInfo.publishedDate).trigger2('input')
                  $('#grape-' + $vue.grape.id + ' #source_description').val(item.volumeInfo.description).trigger2('input')
                  $vue.saveData($vue.grape)
                } else {
                  $('#grape-' + $vue.grape.id + ' #source_description').val('').trigger2('input')
                  $vue.saveData($vue.grape)
                }
              }
            }
          }
        })
      }

      if ($getNewData3 && $vue.grape.sourceID && $vue.grape.grapeType === 'book') {
        // Query book
        booksUrl = 'https://www.googleapis.com/books/v1/volumes?printType=books&q=id:"' + $vue.grape.sourceID + '"&maxResults=1&key=AIzaSyCY-NWXsPHxw-mV_ATX2qdycXSbxtK1zVM'
        $.ajax({
          url: booksUrl,
          dataType: 'jsonp',
          success: function (data) {
            for (var i = 0; i < 1; i++) {
              if (data.items && data.items.length > 0) {
                var item = data.items[i]
                var regex = new RegExp($vue.grape.sourceID)
                if (!item.id.match(regex)) {
                  console.log('docID: ' + $vue.grape.docID + ' and SourceID: ' + $vue.grape.sourceID + ' is incorrect')
                  $('#grape-' + $vue.grape.id + ' #source_description').val('').trigger2('input')
                  $vue.saveData($vue.grape)
                }
              } else {
                console.log('docID: ' + $vue.grape.docID + ' and SourceID: ' + $vue.grape.sourceID + ' is incorrect - no result found')
                $('#grape-' + $vue.grape.id + ' #source_description').val('').trigger2('input')
                $vue.saveData($vue.grape)
              }
            }
          }
        })
      }

      /**********************************************
      ***
      *** Min/Max grape content
      ***
      **********************************************/
      var thisGrape = $('#grape-' + $vue.grape.id)
      var grapeContentWrap = thisGrape.find('.grape-content-wrap')
      var grapeContent = grapeContentWrap.find('.grape-content')
      var grapeContentText = grapeContent.html()
      let cutLength = 280

      // var grapeContentAdjusted = grapeContent.html().replace('É', '...').replace('&Eacute;', '...').replace('Ž', 'é').replace('Ð', '–').replace('ááá', '{>}').replace('á', '{+}')
      var grapeContentAdjusted = grapeContent.html().replace(/\{\+}/g, '+')
      grapeContentAdjusted = grapeContentAdjusted.replace(/\{>}/g, '>')
      grapeContentAdjusted = grapeContentAdjusted.replace(/\{&gt;}/g, '>')
      grapeContentAdjusted = grapeContentAdjusted.replace(/\{<}/g, '<')
      grapeContentAdjusted = grapeContentAdjusted.replace(/\{&lt;}/g, '<')
      // $vue.adjustGrapeContent(grapeContentAdjusted)
      // $vue.saveNewGrapeContent(grapeContentAdjusted)

      if (grapeContentText && grapeContentText.length > cutLength) {
        $vue.replaceGrapeTextSymbols()
        grapeContentWrap.parents('.grape').attr('data-preview', 'true')
        grapeContentWrap.parents('.grape').addClass('preview-mode')

        // Remove blank spaces from bottom
        $(grapeContent.find('p').get().reverse()).each(function () {
          var $thisP = $(this)
          if ($thisP.text() === '') {
            $thisP.remove()
          } else {
            return false
          }
        })
      } else {
        $vue.replaceGrapeTextSymbols()
      }

      grapeContentWrap.click(function (event) {
        event.preventDefault()
        var currentGrapePreview = $(this).parents('.grape').hasClass('preview-mode')
        $('body').removeClass('grape-is-selected')
        $('.grape').removeClass('selected-grape')
        // $('.grape[data-preview="true"]').addClass('preview-mode')

        if (!currentGrapePreview) {
          var $highlightedText = ''
          if (window.getSelection) {
            $highlightedText = window.getSelection().toString()
          }
          if ($highlightedText === '') {
            $(this).parents('.grape').addClass('preview-mode')
          } else {
            $('.body').addClass('grape-is-selected')
            $(this).parents('.grape').addClass('selected-grape').removeClass('preview-mode')
          }
        } else {
          $('body').addClass('grape-is-selected')
          $(this).parents('.grape').addClass('selected-grape').removeClass('preview-mode')
        }
      })

      /**********************************************
      ***
      *** Get Book Sale Links
      ***
      **********************************************/
      function getAmazonBook (isbn) {
        console.log('getAmazonBook')
        $.ajax({
          url: 'http://swiftideas.com/grapevine/amazon.php',
          method: 'GET',
          data: {'q': isbn},
          dataType: 'json',
          success: function (data) {
            console.log(data)
          }
        })
      }
      // getAmazonBook('9781784870874')
    },
    components: {
      GrapeForm
    }
  };
</script>
<style>
  .grape .grape-content p {
    margin-top: 0;
    margin-bottom: 0;
    min-height: 20px;
    line-height: 1.4em;
  }
  .grape .grape-content .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }
  .context-menu-item.new-grapevine-trigger {
    font-weight: bold;
    color: #666;
  }
  .context-menu-item.new-grapevine-trigger.context-menu-hover {
    color: #fff;
  }
  .context-menu-item.context-menu-separator {
    padding: 0;
    margin: 0;
  }
  .context-menu-item.context-menu-disabled h4 {
    margin: 0;
    color: #222;
  }
  #dialog-new-flag {
    padding: 1em;
  }
  #dialog-new-flag textarea {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    padding: 10px;
    font-size: 0.9em;
  }
  #dialog-new-grapevine {
    padding: 1em;
  }
  #context_new_grapevine_name {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  .circ {
    opacity: 0;
    stroke-dasharray: 130;
    stroke-dashoffset: 130;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;
  }
  .tick {
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
    -webkit-transition: stroke-dashoffset 1s 0.5s ease-out;
    -moz-transition: stroke-dashoffset 1s 0.5s ease-out;
    -ms-transition: stroke-dashoffset 1s 0.5s ease-out;
    -o-transition: stroke-dashoffset 1s 0.5s ease-out;
    transition: stroke-dashoffset 1s 0.5s ease-out;
  }
  .add-confirmation .add-trigger.drawn + svg .path {
    opacity: 1;
    stroke-dashoffset: 0;
  }
  .ui-grape-img-tooltip {
    max-width: 180px;
    padding: 20px;
    box-sizing: border-box;
    font-size: 0.9em;
    line-height: 1.4em;
    box-shadow: 2px 2px 1px rgba(0,0,0,0.4);
  }
  .ui-grape-img-tooltip span {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    color: #999;
  }
  .ui-grape-small-tooltip {
    max-width: 180px;
    padding: 4px 6px;
    box-sizing: border-box;
    font-size: 0.9em;
    line-height: 1.2em;
    box-shadow: 2px 2px 1px rgba(0,0,0,0.4);
  }
  .ui-grape-small-tooltip span {
    display: block;
    margin-top: 8px;
    font-size: 12px;
    color: #999;
  }
  .limit-context-size {
    max-height: 600px;
    overflow-y: scroll;
  }
  .grapes-grapevines li {
    padding: 5px 0;
  }
  .grapes-grapevines li a {
    text-decoration: none;
    color: #36a731;
  }
  .grapes-grapevines li:hover a {
    color: #222;
  }
</style>

<style scoped>
  .share-grape-overlay {
    position: fixed;
    background: rgba(0,0,0,0.8);
    width: 100vw;
    height: 100vh;
    left: 0;
    z-index: 999;
    overflow: hidden;
    padding: 5vh 0;
    bottom: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .share-grape-inner {
    max-width: 340px;
    margin: 0 auto;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
    position: relative;
    margin-top: 20vh;
  } 
  .share-grape-inner .modal-close {
    position: absolute;
    top: -50px;
    right: -10px;
    width: 38px;
    font-size: 32px;
    color: #fff;
  }
  .share-grape-inner h3 {
    font-size: 22px;
  }
  .share-grape-inner .aux-links {
    margin: 0 0 20px;
    padding: 0;
    list-style: none;
    display: inline-block;
  }
  .share-grape-inner .aux-links li {
    display: inline-block;
    margin: 10px 20px;
  }
  .share-grape-inner .aux-links li a {
    color: #36a731;
    font-size: 28px;
  }
  .grape-img-mobile-wrap {
    display: none;
  }
  .grape-wrap {
    position: relative;
  }
  .grape-wrap.is-editing {
    height: 100vh;
    min-height: 600px;
  }
  .grape-wrap {
    margin-bottom: 40px;
  }
  .grape-wrap .grape-edit-wrap {
    position: fixed;
    background: rgba(115, 115, 115, 0.8);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    overflow-y: scroll;
    padding: 60px 0;
    bottom: 0;
    box-sizing: border-box;
  }
  .grape-wrap .grape-edit-wrap > .container {
    width: 1000px;
    max-width: 60%;
    background: #fff;
    margin: 0 auto;
    padding: 50px 0;
    box-sizing: border-box;
    height: auto;
    position: relative;
  }
  .grape-wrap .grape-outer-wrap {
    width: 100%;
  }
  .grape .grape-details {
    padding-top: 10px;
    border-top: 1px solid #ccc;
    margin-bottom: 30px;
  }
  .grape .grape-details .username {
    float: left;
    font-size: 1em;
  }
  .grape .grape-details .username > a {
    text-decoration: none;
    color: #169a16;
  }
  .grape .grape-details .username > a > i {
    margin-right: 10px;
  }
  .grape .grape-details .username > a span {
    vertical-align: 1px;
  }
  .grape .grape-details .word-count {
    float: right;
    font-size: 1em;
  }
  .grape .grape-details .word-count > i {
    margin-left: 10px;
    font-size: 0.8em;
  }
  .grape .grape-left {
    word-break: break-word;
    text-align: left;
  }
  .grape-left-inner {
    width: 100%;
    max-width: 128px;
    display: inline-block;
    text-align: left;
    overflow: hidden;
  }
  .grape .grape-img-wrap {
    min-height: 220px;
    position: relative;
  }
  .grape[data-pro="true"] .grape-img-wrap {
    min-height: 0;
  }
  .grape[data-type="url"] .grape-img-wrap {
    min-height: 0;
    margin-bottom: 10px;
    overflow: hidden;
    padding: 0 25px;
    box-sizing: border-box;
  }
  .grape[data-type="url"] .grape-img-wrap > i {
    position: absolute;
    bottom: 10px;
    right: 10px;
    padding: 10px;
    box-sizing: border-box;
    background: #485057;
    color: #fff;
  }
  .grape .grape-img {
    display: inline-block;
    margin-bottom: 15px;
    max-width: 100%;
  }
  .grape[data-type="url"] .grape-img {
    cursor: pointer;
    max-width: none;
    width: 150%;
    min-height: 0;
    margin-left: -25%;
    margin-bottom: 0;
    display: block;
  }
  .grape .grape-source {
    clear: both;
    width: 128px;
    max-width: 100%;
    display: inline-block;
    text-align: left;
    margin-bottom: 5px;
    font-size: 1.1em;
    color: #169a16;
    font-style: italic;
    text-decoration: none;
  }
  .grape .grape-source-date {
    width: 128px;
    max-width: 100%;
    display: inline-block;
    text-align: left;
    font-size: 13px;
  }
  .grape .book-ref-link {
    display: inline-block;
    margin-top: 30px;
    width: 128px;
    text-align: center;
    border-radius: 20px;
    padding: 6px 20px;
  }
  .grape .grape-center {
    text-align: left;
    padding-left: 30px;
    box-sizing: border-box;
  }
  .grape .grape-notes {
    margin-bottom: 20px;
    text-align: left;
    font-size: 14px;
    font-style: italic;
  }
  .grape .grape-notes:empty {
    display: none;
  }
  .grape .grape-content {
    margin-bottom: 30px;
    text-align: left;
    line-height: 1.4em;
  }
  .grape .grape-content, .grape .grape-content span, .grape .grape-content p, .grape .grape-content * {
    font-size: 17px!important;
  }
  .grape .grape-content-wrap {
    position: relative;
    margin-bottom: 40px;
    z-index: 1;
  }
  .grape.preview-mode .hide-when-min {
    display: none;
  }
  .grape.preview-mode[data-single="true"] .hide-when-min {
    display: block;
  }
  .grape.preview-mode .grape-content-wrap {
    height: 120px;
    overflow: hidden;
  }
  .grape .grape-content-preview-overlay {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
    /* IE9 SVG, needs conditional override of 'filter' to 'none' */
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIgc3RvcC1vcGFjaXR5PSIwIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmZmZmZmYiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,0)), color-stop(100%,rgba(255,255,255,1))); /* Chrome4-9,Safari4-5 */
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: -o-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Opera 11.10-11.50 */
    background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* IE10 preview */
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-8 */
  }
  .grape.preview-mode .grape-content-wrap .grape-content-preview-overlay {
    display: block;
  }
  .grape.preview-mode[data-single="true"] .grape-content-wrap {
    height: auto;
    overflow: visible;
  }
  .grape.preview-mode[data-single="true"] .grape-content-wrap .grape-content-preview-overlay {
    display: none;
  }
  .grape-rate {
    text-align: center;
    margin-top: 15px;
    margin-bottom: 30px;
  }
  .grape-rate h5 {
    margin-top: 0;
    font-size: 15px;
  }
  a.grape-aux-button {
    display: block;
    background: #36a731;
    color: #fff;
    text-decoration: none;
    padding: 10px 20px;
    font-size: 0.9em;
    text-align: center;
    margin-bottom: 10px;
  }
  .aux-buttons {
    text-align: center;
    margin-bottom: 40px;
  }
  .aux-buttons a.grape-aux-button {
    display: inline-block;
    padding: 12px 26px;
    margin: 0 2px;
  }
  a.grape-aux-button.add-note-button {
    background-color: #58BF55;
  }
  a.grape-aux-button.share-button {
    background-color: #33B32C;
  }
  a.grape-aux-button.vine-this-button {
    background-color: #30A42A;
  }
  a.grape-aux-button.flag-this-button {
    background-color: #A3ABB3;
  }
  .grape-action {
    text-align: center;
  }
  .grape-left .grape-source-link {
    font-weight: bold;
    font-size: 12px;
  }
  .grape-left .grape-original-date {
    padding-top: 20px;
    margin-top: 20px;
    display: inline-block;
    font-weight: 100;
    font-size: 15px;
    width: 128px;
    text-align: left;
  }
  .grape-left .grape-original-date > span {
    font-size: 16px;
    display: inline-block;
    margin-top: 5px;
  }
  .grape-left .grape-translation {
    line-height: 1.6em;
    font-weight: 100;
    font-size: 15px;
    text-align: left;
    padding-top: 20px;
    margin-top: 20px;
    width: 128px;
    display: inline-block;
  }

  .grape-left .powered-by {
    font-weight: bold;
    font-size: 12px;
    border-top: 2px solid #eee;
    padding-top: 30px;
    margin-top: 30px;
    display: inline-block;
    width: 100%;
  }

  .grape-left .powered-by > img {
    max-width: 60px;
    margin: 10px 0;
    display: block;
  }

  .grape-tags-icon-trigger {
    cursor: pointer;
    margin-left: 5px;
    -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  .grape-tags-icon-trigger:hover {
    opacity: 0.8;
  }

  .grape-left .grape-tags-trigger {
    font-weight: bold;
    font-size: 16px;
    border-top: 2px solid #222;
    padding-top: 30px;
    margin-top: 30px;
    display: inline-block;
    width: 100%;
  }

  .grape-left .grape-tags-trigger > h5 {
    border-bottom: 1px solid #36a731;
    display: inline-block;
    padding-bottom: 4px;
    -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }

  .grape-left .grape-tags-trigger > h5:hover {
    padding-bottom: 8px;
    color: #36a731;
    cursor: pointer;
  }

  .grape-center .grape-author {
    font-variant-caps: all-small-caps;
    font-size: 24px;
    font-weight: 400;
    color: black;
    margin: 0 0 10px;
    padding-top: 20px;
  }
  .grape-center .grape-author a {
    text-decoration: none;
    color: #43B73B;
  }

  .grape-center .title-divide {
    font-variant: all-small-caps;
    font-weight: 100;
    font-size: medium;
  }

  .grape-center h3.grape-title {
    margin-top: .8em;
    font-size: 1.2em;
    margin-bottom: 30px;
  }

  .grape-center-divide {
    height: 1px;
    width: 50%;
    background: #eee;
    margin-bottom: 30px;
  }

  .grape-action a {
    text-decoration: none;
  }

  .grape-right {
    text-align: right;
  }

  .grape-right .grape-right-inner {
    width: 100%;
    max-width: 128px;
    display: inline-block;
    text-align: right;
    padding-top: 20px;
  }
  .grape-right-inner .grape-aux-button {
    width: 102px;
    float: right;
    box-sizing: border-box;
    padding: 14px 20px;
  }
  .grape-right .aux-links li.add-to-grapevine {
    margin-right: 0;
    margin-bottom: 40px;
    display: block;
    text-align: center;
    position: relative;
  }
  .grape-right .aux-links li svg {
    vertical-align: -6px;
  }
  .grape-right .add-confirmation {
    margin-top: 0;
    padding-bottom: 15px;
    position: relative;
    cursor: pointer;
    width: 102px;
    text-align: left;
    float: right;
  }
  .grape-right .add-confirmation {
    height: 0;
    padding-bottom: 0;
  }
  .grape-right .add-confirmation.added {
    height: auto;
    padding-top: 10px;
    padding-bottom: 15px;
  }
  .grape-right .add-confirmation svg {
    font-size: 18px;
    width: 24px;
    height: 24px;
  }
  .grape-right .add-confirmation span {
    font-weight: 100;
    color: #36a731;
    vertical-align: 7px;
    margin-left: 6px;
    opacity: 0;
    -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  .grape-right .add-confirmation.added span {
    opacity: 1;
  }
  .grapes-grapevines {
    list-style: none;
    text-align: left;
    box-shadow: 1px 1px 8px -3px rgba(0,0,0,0.4);
    padding: 30px;
    width: 130px;
    position: absolute;
    right: 2px;
    background: #fff;
    top: 20px;
    display: none;
    z-index: 4;
  }
  .grapes-grapevines:empty {
    display: none!important;
  }
  .grape-right .add-confirmation:hover .grapes-grapevines, .grape-right .add-confirmation .grapes-grapevines:hover {
    display: block;
  }
  .grape-right .flag-wrap {
    clear: both;
    display: block;
    float: right;
    width: 102px;
    text-align: left;
    position: relative;
    z-index: 3;
  }
  .grape-right .flag-wrap > a {
    text-decoration: none;
    color: #36a731;
    text-transform: uppercase;
    font-weight: 100;
  }
  .grape-right .flag-wrap > a svg {
    margin-right: 6px;
    width: 20px;
    padding-left: 3px;
    vertical-align: -4px;
  }
  .rate-grape-link {
    display: inline-block;
    text-decoration: none;
    margin: 0 30px;
    border: 1px solid transparent;
    padding: 8px 15px;
    color: #097b1e;
    font-size: 14px;
  }
  .rate-grape-link[data-rating="5"] {
    font-size: 18px;
  }
  .rate-grape-link[data-rating="3"] {
    font-size: 16px;
  }
  .rate-grape-link:hover, .rate-grape-link.current-rating {
    border-color: #36a731;
    color: #36a731;
  }
  .login-to-rate-button-wrap {
    display: none;
    clear: both;
    height: auto;
    overflow: hidden;
    padding: 20px 0 0;
    text-align: center;
  }
  .login-to-rate-button-wrap button {
    background: transparent;
  }
  .grape-notes-count {
    clear: both;
    text-align: left;
    width: 102px;
    float: right;
    color: #36a731;
    margin-bottom: 20px;
  }
  .grape-notes-count span {
    background: #36a731;
    color: #fff;
    font-size: 18px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    vertical-align: -1px;
    margin-right: 5px;
  }
  .add-note-form {
    position: relative;
    margin: 20px 20% 30px;
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
  }
  #add_grape_note {
    width: 100%;
    padding: 18px 30px;
    font-size: 0.9em;
    box-sizing: border-box;
    border: 0;
    --webkit-appearance: none;
  }
  .add-note-trigger {
    position: absolute;
    right: 20px;
    top: 50%;
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    cursor: pointer;
  }
  @media only screen and (max-width: 767px) {
    .grape-wrap {
      padding-bottom: 0;
      margin-bottom: 30px;
      border-bottom: 0;
    }
    .grape .grape-details {
      margin-bottom: 20px;
    }
    .grape .grape-details .username {
      font-size: 0.8em;
    }
    .grape .grape-details .word-count {
      font-size: 0.8em;
    }
    .grape-img-mobile-wrap {
      display: block;
      width: 60px;
      margin: 0 20px 20px 0;
      float: left;
      position: relative;
    }
    .grape .grape-img-mobile-wrap .grape-img {
      margin-bottom: 0;
    }
    .grape[data-type="url"] .grape-img-mobile-wrap > i {
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 4px;
      box-sizing: border-box;
      box-sizing: border-box;
      background: #485057;
      color: #fff;
      font-size: 10px;
    }
    .grape[data-type="url"] .grape-img-mobile-wrap .grape-img {
      max-width: 100%;
      margin-left: 0;
    }
    .grape-center {
      width: 100%;
      text-align: left;
    }
    .grape-center-divide {
      width: 100%;
      margin-bottom: 20px;
      clear: both;
    }
    .grape-center .title-divide {
      display: none;
    }
    .grape .grape-notes {
      clear: both;
    }
    .grape .grape-center {
      padding-left: 0;
    }
    .grape .grape-content-wrap {
      clear: both;
      margin-bottom: 0;
      margin-left: 0;
    }
    .grape-action {
      display: none;
      margin-bottom: 20px;
    }
    .grape-center .grape-author {
      padding-top: 0;
      margin-bottom: 6px;
    }
    .grape-center h3.grape-title {
      margin-top: 0;
      margin-left: 0;
    }
    .grape-rate {
      margin-bottom: 30px;
    }
    .rate-grape-link {
      margin: 0 15px;
      padding: 6px 10px;
    }
    .aux-buttons {
      margin-bottom: 30px
    }
    .aux-buttons a.grape-aux-button {
      padding: 12px 18px;
    }
    .grape-right {
      width: 100%;
      position: relative;
      z-index: 2;
    }
    .preview-mode .grape-right {
      display: none;
    }
    .preview-mode[data-single="true"] .grape-right {
      display: block;
    }
    .grape-right .grape-right-inner {
      width: 100%;
      max-width: 100%;
      text-align: left;
      position: relative;
      padding: 0;
    }
    .grape-right .grape-right-inner .grape-aux-button {
      display: none;
    }
    .grape-right .aux-links-outer {
      margin-top: 15px;
      float: left;
    }
    .grape-right .aux-links li.add-to-grapevine {
      display: inline-block;
      width: 100px;
      margin: 0 10px;
    }
    .grape-right .add-confirmation {
      margin-top: 0;
      margin-left: 5px;
      position: relative;
      text-align: center;
      padding: 0;
      float: none;
      margin: 0;
      display: inline-block;
    }
    .grape-right .add-confirmation.added {
      padding: 0;
    }
    .grapes-grapevines {
      right: auto;
      left: 0;
      margin: 0;
      position: relative;
      width: 100%;
      width: 60vw;
    }
    .grape-right .flag-wrap {
      float: left;
      clear: none;
      margin-top: 18px;
      margin-left: 15px;
      padding: 8px 0px;
      width: auto;
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .grape-right .flag-wrap > a svg {
      margin-right: -2px;
    }
    .login-to-rate-button-wrap {
      display: block;
    }
  }
  @media only screen and (max-width: 320px) {
    .aux-buttons a.grape-aux-button {
      padding: 8px 12px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Grape.vue